<template>
  <div class="container">
    <div class="ui left aligned grid">
        <h1>{{title}} Navigation Link</h1>
    </div>
    <form class="ui form segment" @submit.prevent="navigationUpdate">
        <div class="ui grid stackeable">
           <div class="row">
               <div class="eight wide column">
                    <label>Link Name</label>
                    <input type="text" name="LinkName" placeholder="Link Name" v-model="name">
                </div>
                 <div class="eight wide column">
                    <label>URL</label>
                    <input type="text" name="URL" placeholder="URL" v-model="url">
                </div>
            </div>

            <div class="row">
               <!-- <div class="eight wide column">
                    <label>Location</label>
                    <div class="ui fluid selection dropdown" id="locationSelect">
                        <input type="hidden" name="Location" id="Location" v-model="locationId" @change="onLocationChange"/>
                        <div class="default text">Select Location</div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div class="item" v-for="location in locationList" :key="location.value" v-bind:data-value="location.value">
                            {{location.text}}
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="four wide column middle aligned content">
                    <label for="header" class="toggle label">Show in Header?</label>
                    <div class="ui toggle checkbox">
                        <input id="header" name="header" type="checkbox" tabindex="0" class="" v-model="header">
                        <label for="header">Show</label>
                    </div>
                </div>

                <div class="four wide column middle aligned content">
                    <label for="footer" class="toggle label">Show in Footer?</label>
                    <div class="ui toggle checkbox">
                        <input id="footer" name="footer" type="checkbox" tabindex="0" class="" v-model="footer">
                        <label for="footer">Show</label>
                    </div>
                </div>

                 <div class="eight wide column">
                    <label>Parent Navigation</label>
                    <div class="ui fluid selection dropdown" id="navigationSelect">
                        <input type="hidden" name="navigationItem" id="navigationItem" v-model="navigationId" @change="onNavigationChange"/>
                        <div class="default text">Select Location</div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div class="item" v-for="navigationItem in navigationItemList" :key="navigationItem.value" v-bind:data-value="navigationItem.value">
                            {{navigationItem.text}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
               <div class="eight wide column">
                    <label>Target</label>
                    <div class="ui fluid selection dropdown" id="targetSelect">
                        <input type="hidden" name="Target" id="Target" v-model="target" @change="onTargetChange"/>
                        <div class="default text">Select Target</div>
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <div class="item" v-for="target in targets" :key="target.value" v-bind:data-value="target.value">
                            {{target.text}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="eight wide column">
                    <label>Sort Order</label>
                    <input type="text" name="SortOrder" placeholder="0" v-model="sortOrder">
                </div>
            </div>

            <div class="row">
                <div class="eight wide column">
                    <label>Tag Tile</label>
                    <input type="text" name="Tag" placeholder="Tag" v-model="tag">
                </div>
            </div>

            <div class="row">
                <div class="eight wide column">
                     <div class="ui buttons">
                        <button class="ui positive button">{{button}} Navigation Item</button>
                        <div class="or"></div>
                        <div class="ui light button" @click="$router.go(-1)">Cancel</div>
                    </div>
                </div>

                 <div class="eight wide column">
                    <div class="ui primary button right floated"  @click="deleteModal">Delete Navigation Item</div>
                </div>
            </div>
        </div>
    </form>

    <semantic-modal medium flip vertical :active.sync="showModal">
		<i class="close icon"></i>
		<div class="header">
			Are you sure you want to delete this navigation item?
		</div>
		<div class="actions">
			<div class="ui black deny button" @click="showModal = false">
			Nope
			</div>
			<div class="ui positive right labeled icon button" @click="navigationDelete(id)">
			Yes
			<i class="checkmark icon"></i>
			</div>
		</div>
	</semantic-modal>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

import SemanticModal from 'vue-ya-semantic-modal'

export default {
    name: 'EditNav',
    components: {
		SemanticModal: SemanticModal()
    },
    mounted() {
        $('.ui.dropdown').dropdown();
        this.getNavigationSelectedItems();
        if (this.$route.params.id == undefined) {
            this.button = 'Add';
            this.title = 'Add';
            return false;
        } else {
            this.getNavigationDetails();
            this.button = 'Save';
            this.title = 'Edit';
        }	
	},
	data() {
		return {
            showModal: false,
            id: "",
            value: null,
            name: "",
            url: "",
            navigationItem: "",
            navigationItemList: [],
            navigationId: "",
            sortOrder: "",
            tag: "",
            header: false,
            footer: false,
            target: "",
            targets: [{
                text: 'Same Window',
                value: 1,
            }, {
                text: 'New Window',
                value: 2,
            }],
            error: false,
            button: "",
            title: ""
		};
	},
    methods: {
		deleteModal(){
            this.showModal = !this.showModal;
        },
        onLocationChange(event) {
            this.locationId = event.target.value;
        },
        onNavigationChange(event) {
            this.navigationId = event.target.value;
        },
        onTargetChange(event) {
            this.target = event.target.value;
        },
        getNavigationSelectedItems() {
            apiService.getNavigationSelectedItems().then(data => {
                this.navigationItemList = data;
            });  
        },
		getNavigationDetails() {
            apiService
                .getNavigationDetails({ id: this.$route.params.id })
                .then(request => {
                    setTimeout(function() {
                        $("#navigationSelect").dropdown("set selected", this.navigationId);
                        $("#targetSelect").dropdown("set selected", this.target);

                        $('.ui.dropdown .remove.icon').on('click', function(e){
                            $(this).parent('.dropdown').dropdown('clear');
                            e.stopPropagation();
                        });	
                    }, 500);
                    this.navigationSuccessful(request);
                })
                .catch(err => this.navigationFailed(err));
		},
		navigationSuccessful(request) {
			(this.name = request.name),
            (this.url = request.url),
            (this.target = request.target),
            (this.header = request.header),
            (this.footer = request.footer),
            (this.navigationItem = request.navigationItem),
            (this.navigationId = request.navigationId),
            (this.sortOrder = request.sortOrder),
            (this.tag = request.tag),
			(this.active = request.active);
		},
		navigationFailed(err) {
            this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
                title: err.error.response.data.title,
                autoHideDelay: 10000,
                appendToast: false,
                variant: "danger",
                solid: true
            });
        },
		navigationUpdate() {
			if(this.$route.params.id == undefined) {
				// console.log('create');
				// console.log(this.machineCode);
				apiService
				.createNavigation({
                    name: this.name,
                    url: this.url,
                    target: this.target,
                    header: this.header,
                    footer: this.footer,
                    navigationItem: this.navigationItem,
                    navigationId: this.navigationId,
                    sortOrder: this.sortOrder,
                    tag: this.tag,
                    Active: this.active,
				})
				.then(request => {
					// console.log(this.active);
					
						this.navigationSuccessful(request);
						this.$router.push('/admin/navigation/index');
					})
				.catch(err => this.navigationFailed(err));
			} else {
				// console.log('edit');
				apiService
				.updateNavigation({
                    id: this.$route.params.id,
                    name: this.name,
                    url: this.url,
                    target: this.target,
                    header: this.header,
                    footer: this.footer,
                    navigationItem: this.navigationItem,
                    navigationId: this.navigationId,
                    sortOrder: this.sortOrder,
                    tag: this.tag,
                    Active: this.active,
				})
				.then(request => {
						this.navigationSuccessful(request);
						this.$router.push('/admin/navigation/index');
					})
				.catch(err => this.navigationFailed(err));
			}
		},
		navigationDelete() {
			apiService
				.deleteNavigation({ id: this.$route.params.id })
				.then(request => {
						this.navigationSuccessful(request);
						this.showModal = this.showModal;
						this.$router.push('/admin/navigation/index');
					})
				.catch(err => this.navigationFailed(err));
		}
	}
}

</script>

<style module>

</style>